import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBook1 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 18 18",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3 4.125h3.75a1.5 1.5 0 0 1 1.5 1.5v8.669l-.333-.111a6 6 0 0 0-1.897-.308H3zm6 12-1.557-.52a4.5 4.5 0 0 0-1.423-.23H1.5V2.625h5.25c.896 0 1.7.393 2.25 1.016a3 3 0 0 1 2.25-1.016h5.25v12.75h-4.52a4.5 4.5 0 0 0-1.423.23zm.75-10.5v8.669l.333-.111a6 6 0 0 1 1.897-.308H15v-9.75h-3.75a1.5 1.5 0 0 0-1.5 1.5",
		clipRule: "evenodd"
	})
});
export default SvgBook1;
